import { render } from "./ItemScroll.vue?vue&type=template&id=373eb5fc"
import script from "./ItemScroll.vue?vue&type=script&lang=js"
export * from "./ItemScroll.vue?vue&type=script&lang=js"

import "./ItemScroll.vue?vue&type=style&index=0&id=373eb5fc&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__